module.exports = __webpack_public_path__ + "static/img/RAPD-1U305-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD-1U305-G_1.png
// module id = +wpE
// module chunks = 0